import EditReviewTypes from "./ReviewTypes/EditReviewTypes"

let reviewParams: EditReviewTypes | any = {
    EmployeeReviewId: null,
    EmployeeId: null,
    ReviewDate: null,
    ReviewScore: null,
    EmployeeReviewStatusId: null,
    ProfitCenterId: null,
    EmployeeReviewTypeId: null,
    EmployeeReviewReasonId: null,
    CurrentJobTitleId: null,
    NewJobTitleId: null,
    SubmittedDateUtc: null,
    SubmittedBy: null,
    ManagerApprovedDateUtc: null,
    ManagerApprovedBy: null,
    HRApprovedDateUtc: null,
    HRApprovedBy: null,
    Comments: null,
    CreatedDateUtc: null,
    CreatedBy: null,
    ModifyDateUtc: null,
    ModifiedBy: null,
    DeletedDateUtc: null,
    DeletedBy: null,
    DisabledDateUtc: null,
    DisabledBy: null,
    ReviewedBy: null
}

export default reviewParams